import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import { Bubble, Segment, SegmentProps } from 'tea-component';

import type { IBaseProps } from '@/pages/intelligence/types/common';

const getOptions = (list: IVisualisSegmentOption[], cfg?: { iconable?: boolean }): any[] => {
  if (!Array.isArray(list)) return [];
  const { iconable } = cfg ?? {};
  return list.map((item) => ({
    value: item?.value,
    label: item?.label,
    text: (
      <div className="dbi-pcGame-select-flex">
        {iconable && <img className="dbi-pcGame-select-icon" src={item?.icon} alt="" />}
        <Bubble placement="top" dark content={item?.label}>
          {item?.label}
        </Bubble>
      </div>
    ),
  }));
};

interface IVisualisSegmentOption {
  value: string;
  label: string;
  icon: string;
}

interface IVisualisSegmentProps extends IBaseProps, SegmentProps {
  iconable?: boolean;
  options: IVisualisSegmentOption[];
  value: string;
  onChange: (payload: string) => void;
}

const VisualisSegment: React.FC<IVisualisSegmentProps> = (props) => {
  const { iconable, options: optionsOuter, value: valueOuter, onChange } = props;

  const options = getOptions(optionsOuter, { iconable });

  const [value, setValue] = useState(valueOuter);

  const handleChange = (payload: string) => {
    setValue(payload);
    onChange(payload);
  };

  useEffect(() => {
    if (valueOuter === value) return;
    setValue(valueOuter);
  }, [valueOuter]);

  return (
    <Segment
      className={classnames({
        'dbi-pcGame-segment-box': iconable,
      })}
      options={options}
      value={value}
      onChange={handleChange}
    />
  );
};

export default VisualisSegment;
